export default __webpack_public_path__ + "static/media/logo-snap.19763c6a.png";